import React, { useState, useEffect } from 'react';
import {
	Typography,
	Radio,
	Row,
	Col,
	Upload,
	Button,
	notification,
	Dropdown,
	Space,
	message,
	Card,
	Divider
} from 'antd';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../../environment';
import { useTranslation } from 'react-i18next';
import { refreshData } from '../../../store/auth/actions';
import {
	CheckOutlined,
	DeleteOutlined,
	DownloadOutlined,
	MoreOutlined,
	LikeOutlined,
	ExclamationCircleOutlined,
	ClockCircleOutlined,
	FileOutlined
} from '@ant-design/icons';
import { isMobileOnly } from 'react-device-detect';
import _ from 'lodash';
import { showPay } from '../../../store/data/actions';
import { useDispatch } from 'react-redux';
import CheckOutComponent from '../CheckOutComponent';
import plusDocuments from '../../../assets/onboarding/plusDocuments.png';
import moment from 'moment';
import tagSabadell from '../../../components/tagSabadell';
import eventSabadell from '../../../components/eventSabadell';
import i18n from '../../../i18n';
import DeleteDocumentModal from 'mortgage-documents/src/document-boxes/modals/DeleteDocumentModal';

const { Text } = Typography;

const AppraisalOffice = ({ dataMortgage, operationId, stages, existAppraisal, getAppraisal }) => {
	const { t } = useTranslation();
	const [mortgageData, setMortgageData] = useState();
	const userToken = useSelector((state) => state.auth.token);
	const [valueRadio, setValueRadio] = useState(undefined);
	const [typeFile, setTypeFile] = useState(undefined);
	const [saveFileDataField, setSaveFileDataField] = useState(null);
	const [deleteModal, setDeleteModal] = useState({ show: false, documentId: undefined });
	const [substage, setSubstage] = useState(undefined);

	useEffect(() => {
		if (operationId) {
			getMortgageData();
			getsubstage();
			eventSabadell('ya tengo');
		}
	}, []);

	const getsubstage = () => {
		axios
			.get(`${env.api.url}/sb/mortgages/protagoras-operations/get-substage/${operationId}`, {
				headers: {
					Authorization: `Bearer ${userToken}`
				}
			})
			.then((response) => {
				setSubstage(response.data.data);
			});
	};

	const handleUploadFile = (file) => {
		if (
			file[1].fileName.includes('.jpg') ||
			file[1].fileName.includes('.jpeg') ||
			file[1].fileName.includes('.png') ||
			file[1].fileName.includes('.pdf') ||
			file[1].fileName.includes('.xlsx') ||
			file[1].fileName.includes('.doc') ||
			file[1].fileName.includes('.docx') ||
			file[1].fileName.includes('.heic') ||
			file[1].fileName.includes('.webp')
		) {
			axios
				.put(
					`${env.api.url}/api/mortgages/attachment`,
					{
						mortgageId: operationId,
						file: file[1].file,
						fileName: file[1].fileName,
						type: typeFile,
						owner: 'owner1'
					},
					{
						headers: { Authorization: `Bearer ${userToken}` }
					}
				)
				.then((response) => {
					getAppraisal();
					if (response?.data?.type === 'appraisal') {
						message.success({
							style: {
								border: '2px solid #239D45',
								width: 'fit-content',
								margin: '0 auto',
								background: '#fff',
								borderRadius: 4,
								textAlign: 'left'
							},
							content: (
								<Text style={{ fontSize: 16, color: '#239D45', fontWeight: 500 }}>
									{t('doc.notiNew')}
									<br />
									<span style={{ fontSize: 14, fontWeight: 400, color: '#212121', marginLeft: 24 }}>
										{t('appraisal.contactMessage')}
									</span>
								</Text>
							),
							icon: <LikeOutlined style={{ color: '#239D45' }} />
						});
					}
				})
				.catch(() => {
					message.error({
						style: {
							border: '2px solid #BE0028',
							width: 'fit-content',
							margin: '0 auto',
							background: '#fff',
							borderRadius: 4,
							textAlign: 'left'
						},
						content: (
							<Text style={{ fontSize: 16, color: '#BE0028', fontWeight: 500 }}>
								{t('doc.errorOcurred')}
								<br />
								<span style={{ fontSize: 14, fontWeight: 400, color: '#212121', marginLeft: 24 }}>
									{t('doc.reuploadDocument')}
								</span>
							</Text>
						),
						icon: <ExclamationCircleOutlined style={{ color: '#BE0028' }} />
					});
				});
		} else {
			message.error({
				style: {
					border: '2px solid #BE0028',
					width: 'fit-content',
					margin: '0 auto',
					background: '#fff',
					borderRadius: 4,
					textAlign: 'left'
				},
				content: (
					<Text style={{ fontSize: 16, color: '#BE0028', fontWeight: 500 }}>
						{t('doc.errorOcurred')}
						<br />
						<span style={{ fontSize: 14, fontWeight: 400, color: '#212121', marginLeft: 24 }}>
							{t('files.allowedFormats')}
						</span>
					</Text>
				),
				icon: <ExclamationCircleOutlined style={{ color: '#BE0028' }} />
			});
		}
	};

	const saveFileData = (file, name) => {
		const documentFile = [saveFileDataField];
		documentFile.push({
			file,
			fileName: name
		});
		setSaveFileDataField(documentFile);
		handleUploadFile(documentFile);
	};

	const uploadProps = {
		beforeUpload: (file) => {
			return new Promise(() => {
				const reader = new FileReader();
				reader.readAsDataURL(file);

				if (file.size < 50000000) {
					reader.onload = () => {
						const base64File = reader.result.split(',')[1];
						saveFileData(base64File, file.name);
					};
				} else {
					notification.error({
						message: 'Problema al subir archivo',
						description:
							'Documento demasiado pesado, debe subir documentos que no superen los 50MB por seguridad.'
					});
				}
			});
		}
	};

	const handleClickPlus = (typeFile) => {
		tagSabadell('tasacion informe propia', i18n.language === 'cat' ? 'ca' : 'es');
		setTypeFile(typeFile);
		getAppraisal();
	};

	const deleteDocument = () => {
		if (!_.isNil(existAppraisal.page)) {
		} else {
			axios
				.get(`${env.api.url}/v1/documents/delete-document/${existAppraisal.id}`, {
					headers: { Authorization: `Bearer ${userToken}` }
				})
				.then(() => {
					setDeleteModal({ show: false, documentId: undefined });
					getAppraisal();
				});
		}
	};

	const getMortgageData = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/data/get/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setMortgageData(response.data.data.mortgage);
				if (response.data.data.mortgage.reportAppraisal !== undefined) {
					setValueRadio(response.data.data.mortgage.reportAppraisal);
				}
			});
	};

	const saveDataOnClick = (participant, key, value) => {
		let valueRadio = {
			key: 'operation',
			subkey: 'firstClickToAppraisal',
			value: moment().format('YYYY-MM-DD')
		};

		if (mortgageData?.reportAppraisal !== undefined) {
			valueRadio = {
				key: 'operation',
				subkey: 'ultimateClickToAppraisal',
				value: moment().format('YYYY-MM-DD')
			};
		}

		axios
			.post(
				`${env.api.url}/v1/mortgages/data/multiple/update/${operationId}`,
				{
					values: [
						{
							key: participant,
							subkey: key,
							value: value
						},
						{
							key: valueRadio.key,
							subkey: valueRadio.subkey,
							value: valueRadio.value
						}
					]
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then(() => {
				getMortgageData();
				refreshData();
			});
	};

	const handleFileDownload = (documentId) => {
		axios
			.get(`${env.api.url}/v1/documents/get-document-url/${documentId}?token=${userToken}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				if (response.data.success) {
					window.open(response.data.data.url, '_blank');
				}
			});
	};

	const items = [
		{
			label: (
				<div
					style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
					onClick={() => setDeleteModal({ show: true, documentId: existAppraisal.id })}>
					<DeleteOutlined className="delete-document" style={{ marginRight: 8 }} />
					<span className="delete-document delete-document-text">{t('loan.delete')}</span>
				</div>
			),
			key: '0'
		},
		{
			label: (
				<div
					style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
					onClick={() => handleFileDownload(existAppraisal.id)}>
					<DownloadOutlined style={{ color: '#006DFF', marginRight: 8 }} />
					<span style={{ color: '#006DFF' }}>{t('init.download')}</span>
				</div>
			),
			key: '1'
		}
	];

	const showNameSpanishStage = (stage) => {
		const substageList = [
			{
				title: 'Pdte. Documentación',
				value: 'awaiting_documents'
			},
			{
				title: 'Pdte. Verificación',
				value: 'awaiting_documents_verification'
			},
			{
				title: 'PDTE.SCORING',
				value: 'scoring_pending'
			},
			{
				title: 'SCORING HECHO',
				value: 'scoring_done'
			},
			{
				title: 'Pdte. Iniciar ER',
				value: 'ER_pending_starting'
			},
			{
				title: 'ER Pdte. de Solvencia',
				value: 'ER_pending_solving'
			},
			{
				title: 'ER elaborado Pdte. de finalizar',
				value: 'ER_approved'
			},
			{
				title: 'ER finalizado esperando traspaso a Sinfonía',
				value: 'formalization_pending_scoring'
			},
			{
				title: 'Pte. firma',
				value: 'formalization_pending_sign'
			},
			{
				title: 'Pte. Fecha de firma',
				value: 'formalization_pending_sign_date'
			},
			{
				title: 'Pte. contratación de seguros',
				value: 'formalization_pending_insurance'
			},
			{
				title: 'Pte. FEIN firmada',
				value: 'formalization_pending_FEIN_signed'
			},
			{
				title: 'Pte. Emisión FEIN',
				value: 'formalization_pending_FEIN'
			},
			{
				title: 'Pte. de tasación',
				value: 'formalization_pending_appraisal'
			},
			{
				title: 'Pte. IJ disponible',
				value: 'formalization_pending_IJ'
			}
		];

		for (let i = 0; i < substageList.length; i++) {
			if (stage === substageList[i].value) {
				return substageList[i].title;
			}
		}

		return '';
	};

	return (
		<div>
			<Text style={{ color: '#212121', fontSize: 14, fontWeight: 600 }}>
				{t('appraisal.infoAppraisal')}
			</Text>
			<div style={{ display: 'flex', flexDirection: 'column', marginTop: 8 }}>
				<Radio
					value={'h1'}
					checked={mortgageData && mortgageData.reportAppraisal === 'h1' ? true : false}
					onChange={(e) => {
						saveDataOnClick('mortgage', 'reportAppraisal', e.target.value);
						setValueRadio(e.target.value);
						eventSabadell('tasacion sabadell');
					}}>
					<Text style={{ color: '#212121', fontSize: 14, fontWeight: 400 }}>
						{' '}
						{t('appraisal.bankAppraisal')}
					</Text>
				</Radio>
				{valueRadio === 'h1' && (
					<Text
						style={{
							color: '#757575',
							fontSize: 12,
							fontWeight: 400,
							marginLeft: 20,
							marginTop: 8,
							marginBottom: 8
						}}>
						{t('appraisal.bankAppraisal2')}
					</Text>
				)}
				<Radio
					value={'own'}
					checked={mortgageData && mortgageData?.reportAppraisal === 'own' ? true : false}
					onChange={(e) => {
						saveDataOnClick('mortgage', 'reportAppraisal', e.target.value);
						setValueRadio(e.target.value);
						eventSabadell('ya tengo');
						tagSabadell('tasacion propia', i18n.language === 'cat' ? 'ca' : 'es');
					}}>
					<Text style={{ color: '#212121', fontSize: 14, fontWeight: 400 }}>
						{t('appraisal.miAppraisal')}
					</Text>
				</Radio>

				{valueRadio !== 'h1' &&
					!_.isNil(valueRadio) &&
					existAppraisal === undefined &&
					mortgageData &&
					mortgageData.reportAppraisal !== 'bank' && (
						<div style={{ marginTop: 8, marginBottom: 12 }}>
							<Upload {...uploadProps}>
								<Button
									onClick={() => handleClickPlus('appraisal')}
									style={{
										width: 'auto',
										height: 78,
										backgroundColor: 'white',
										borderRadius: '4px',
										borderColor: '#BE0028'
									}}>
									<div style={{ display: 'flex', alignItems: 'center', columnGap: 9 }}>
										<div
											style={{
												height: 6,
												width: 6,
												background: 'red',
												borderRadius: '50%'
											}}></div>
										<div
											style={{
												fontSize: '12px',
												whiteSpace: 'break-spaces',
												color: '#212121',
												fontWeight: 400
											}}>
											{t('appraisal.infoAppraisal')}
										</div>
									</div>
									<div style={{ display: 'flex', alignItems: 'center', columnGap: 4 }}>
										<img src={plusDocuments} alt="plusDocuments" height={16} />
										<div
											style={{
												fontSize: '12px',
												whiteSpace: 'break-spaces',
												color: '#006DFF',
												fontWeight: 400,
												textDecorationLine: 'underline'
											}}>
											{t('document.attach')}
										</div>
									</div>
								</Button>
							</Upload>
						</div>
					)}

				{valueRadio !== 'h1' && existAppraisal && existAppraisal?.type === 'appraisal' && (
					<div style={{ marginTop: 8, marginBottom: 12 }}>
						<Button
							onClick={() => handleClickPlus('appraisal')}
							style={{
								width: 'auto',
								height: 78,
								backgroundColor: 'white',
								borderRadius: '4px',
								borderColor: '#239D45'
							}}>
							<div style={{ display: 'flex', alignItems: 'center', columnGap: 9 }}>
								<CheckOutlined style={{ color: '#52C41A' }} />
								<div
									style={{
										fontSize: '12px',
										whiteSpace: 'break-spaces',
										color: '#212121',
										fontWeight: 400
									}}>
									{t('appraisal.infoAppraisal')}
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									alignItems: 'scenter',
									justifyContent: 'space-between',
									columnGap: 4,
									marginTop: 8
								}}>
								<div
									style={{
										fontSize: '12px',
										whiteSpace: 'break-spaces',
										color: '#757575',
										fontWeight: 400
									}}>
									{t('appraisal.appraisal')}.pdf
								</div>
								<Dropdown menu={{ items }} trigger={['click']}>
									<a onClick={(e) => e.preventDefault()}>
										<Space>
											<MoreOutlined />
										</Space>
									</a>
								</Dropdown>
							</div>
						</Button>
					</div>
				)}
			</div>

			<Divider
				type="horizontal"
				style={{ background: '#BDBDBD', marginTop: 10, marginBottom: 16 }}></Divider>

			<div>
				<Text style={{ color: '#212121', fontSize: 14, fontWeight: 600 }}>{t('appraisal.Er')}</Text>
			</div>
			<div>
				<Text style={{ color: '#757575', fontSize: 12, fontWeight: 400 }}>
					{t('appraisal.Er2')}
				</Text>
				<Text style={{ color: '#212121', fontSize: 14, fontWeight: 600 }}>
					&nbsp;
					{showNameSpanishStage(substage?.substage)}
				</Text>
			</div>
			<Divider
				type="horizontal"
				style={{ background: '#BDBDBD', marginTop: 16, marginBottom: 16 }}></Divider>
			<div>
				<Text style={{ color: '#212121', fontSize: 14, fontWeight: 600 }}>
					{t('appraisal.sabAccount')}
				</Text>
			</div>
			<div>
				<Text style={{ color: '#757575', fontSize: 12, fontWeight: 400 }}>
					{t('appraisal.sabAccount2') + ' '}
				</Text>
				<a
					style={{ textDecoration: 'underline', color: '#006DFF', fontSize: 12, fontWeight: 700 }}
					href=" https://cuentaonline.bancsabadell.com/?sem=sem-brand:nf-google:nc-sem_brand%7Cgoogle%7Ccuenta+particulares%7Ces-es%7Cbrand%7Cconv%7Cao%7Cprospect_ex:c-:f-texto:t-:kw-abrir_cuenta_banco_sabadell:mp-cpa:ga-dentsux:tp-prospect:sp-tradicional:pt-googleads:la-:di-all&gad_source=1&gclid=CjwKCAiAhP67BhAVEiwA2E_9g5WSysmCzn67jcizvaZtRLI9mXIw2pTXlplkxu3YMWo6S3vY3_7e5hoCLmoQAvD_BwE&gclsrc=aw.ds"
					target="_blank">
					{t('appraisal.sabAccount3')}
				</a>
			</div>
			<DeleteDocumentModal
				visible={deleteModal.show}
				onCreate={() => deleteDocument(deleteModal.documentId)}
				onCancel={() => setDeleteModal({ show: false, documentId: undefined })}
			/>
		</div>
	);
};

export default AppraisalOffice;
